import React, { useState, useContext, useEffect } from "react";
import { Button, Card, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { apiConfig } from "../../../config";
import useAuth from "../../../hooks/useAuth";
import NotyfContext from "../../../contexts/NotyfContext";
import IsAllowed from "../../../components/IsAllowed";
import NotAuthorised from "../../../components/NotAuthorised";
import axios from "axios";
import { ReactComponent as LogoLoader } from "../../../assets/img/wavenet-animated-loader3.svg";

const Dot11Admin = ({ customerOptions, isLoadingCustomerOptions }) => {
  const { userAccessToken } = useAuth();
  const bearerToken = `Bearer ${userAccessToken}`;

  const [excellId, setExcellId] = useState(null);
  useEffect(() => {
    setExcellId(null);
  }, [customerOptions]);

  const notyf = useContext(NotyfContext);

  const [type] = useState("success");
  const [duration] = useState("5000");
  const [ripple] = useState(true);
  const [dismissible] = useState(false);
  const [positionX] = useState("right");
  const [positionY] = useState("top");

  const handleRebuildVlansSubmit = (event) => {
    event.preventDefault();
    const axiosConfig = {
      headers: { Authorization: bearerToken },
    };
    axios
      .patch(
        `${apiConfig.dot11ApiUrl}users/account/${excellId}/rebuildVlans`,
        null,
        axiosConfig
      )
      .then(function (response) {
        if (response.status === 200) {
          notyf.open({
            type,
            message: response.data.message,
            duration,
            ripple,
            dismissible,
            position: {
              x: positionX,
              y: positionY,
            },
          });
          setExcellId(null);
        } else {
          notyf.open({
            type: "warning",
            message: response.data.message || "Unknown error",
            duration,
            ripple,
            dismissible,
            position: {
              x: positionX,
              y: positionY,
            },
          });
          setExcellId(null);
        }
      })
      .catch(function (error) {
        notyf.open({
          type: "warning",
          message: error.response.data.message || "Unknown error",
          duration,
          ripple,
          dismissible,
          position: {
            x: positionX,
            y: positionY,
          },
        });
        setExcellId(null);
      });
  };

  return (
    <IsAllowed to="view:systemsettings:users" fallback={<NotAuthorised />}>
      <Card.Header>
        <Card.Title className="mb-0">
          Dot11 Radius Tools
          {isLoadingCustomerOptions && (
            <LogoLoader
              className="d-inline-block align-middle ms-2"
              style={{ width: "20px", height: "20px" }}
            />
          )}
        </Card.Title>
      </Card.Header>
      <Card.Body className="py-0">
        <Form onSubmit={handleRebuildVlansSubmit}>
          <Row>
            <Form.Group className="mb-3 col-md-5">
              <Form.Label>Rebuild VLANs for account</Form.Label>
              <Select
                className="react-select-container"
                classNamePrefix="react-select"
                options={
                  isLoadingCustomerOptions
                    ? [{ value: "", label: "Loading..." }]
                    : customerOptions
                }
                isDisabled={
                  isLoadingCustomerOptions || customerOptions.length === 0
                }
                onChange={(e) => setExcellId(e.value)}
                value={
                  excellId
                    ? customerOptions.find(
                        (option) => option.value === excellId
                      )
                    : null
                }
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-3">
              <Button className="btn btn-light btn-lg" type="submit">
                Rebuild VLANs Now
              </Button>
            </Form.Group>
          </Row>
        </Form>
      </Card.Body>
    </IsAllowed>
  );
};

export default Dot11Admin;
